import Emitter from "./Emitter";

export default class OpenPaytable extends Emitter {
    constructor(gb) {
        super(gb);
    }

    HABANERO2_handler(){
        this.emitGame({type: "togglePaytable"})
    }

    _default() {
        this.emitGame({ wpgaction: "openPaytable" });
    }
}
